import { useEffect, useState } from 'react'
import './CopraManagementTool.css'
import { authedGet, authedPost } from '../lib/intranet_tools_service'
import { EditModal } from './EditModal'
import {
  ProfessionalProject as ProfessionalProject,
  ChristmasGift,
  NewChristmasGift,
} from './types'
import { GIFTS, INVOICE_STATUSES, ORDER_STATUSES, reverseDate } from './util'
import { NewModal } from './NewModal'

const DEFAULT_GIFT: NewChristmasGift = {
  FirstName: '',
  LastName: '',
  Email: '',
  Token: '',
}

const parseDateOrNull = (sdate: string | null) => {
  if (sdate === null) return 0
  else return new Date(sdate).getTime()
}

const DateCell = ({ date }: { date: string }) => {
  return <span>{formatDbDate(date)}</span>
}

const formatDbDate = (str: string): string => {
  const parts = str.substr(0, 10).split('-')
  return `${parts[2]}-${parts[1]}-${parts[0]}`
}

const flip = (order: string) => {
  if (order === 'DESC') {
    return 'ASC'
  }
  return 'DESC'
}

const STORAGE_PROFESSIONAL_PROJECTS_SORTING = 'professional_projects_sorting'
const STORAGE_PROFESSIONAL_PROJECTS_FILTER = 'professional_projects_filter'

const getDefaultSortBy = () => {
  const professionalprojectsSortBy = localStorage.getItem(
    STORAGE_PROFESSIONAL_PROJECTS_SORTING
  )
  if (professionalprojectsSortBy) {
    return JSON.parse(professionalprojectsSortBy)
  }
  return ['name', 'ASC']
}

const getFilter = () => {
  const professionalprojectsFilter = localStorage.getItem(
    STORAGE_PROFESSIONAL_PROJECTS_FILTER
  )
  return professionalprojectsFilter || ''
}

export const CopraManagementTool = () => {
  const [christmasGifts, setChristmasGifts] = useState<ChristmasGift[]>()
  const [professionalProjects, setProfessionalProjects] =
    useState<ProfessionalProject[]>()
  const [selected, setSelected] = useState<ProfessionalProject | undefined>()
  const [newGift, setNewGift] = useState<NewChristmasGift | undefined>()
  const [error, setError] = useState('')
  const [sortBy, setSortBy] = useState(getDefaultSortBy())
  const [filterBy, setFilter] = useState(getFilter())

  const loadProfessionalProjects = async () => {
    const result = await authedGet('av/professionals')
    if (!result.ok) {
      const json = await result.json()
      setError('Error updating: ' + json.error)
    } else {
      const json = await result.json()
      setError('')
      setProfessionalProjects(json.data)
    }
  }

  const setSorting = (column: string) => {
    let newSortBy
    if (column === sortBy[0]) {
      newSortBy = [column, flip(sortBy[1])]
    } else {
      newSortBy = [column, 'ASC']
    }
    setSortBy(newSortBy)
    localStorage.setItem(
      STORAGE_PROFESSIONAL_PROJECTS_SORTING,
      JSON.stringify(newSortBy)
    )
  }

  const applyFilter = (sfilter: string) => {
    setFilter(sfilter)
    localStorage.setItem(STORAGE_PROFESSIONAL_PROJECTS_FILTER, sfilter)
  }

  const containsInsensitive = (string1: string, string2: string): boolean => {
    return string1.toLowerCase().indexOf(string2.toLowerCase()) !== -1
  }

  useEffect(() => {
    loadProfessionalProjects()
  }, [])

  const sorted = professionalProjects
    ?.sort((a, b) => {
      switch (sortBy[0]) {
        case 'dateStart':
          return sortBy[1] === 'ASC'
            ? parseDateOrNull(a.StartDate) - parseDateOrNull(b.StartDate)
            : parseDateOrNull(b.StartDate) - parseDateOrNull(a.StartDate)
        case 'dateEnd':
          return sortBy[1] === 'ASC'
            ? parseDateOrNull(a.EndDate) - parseDateOrNull(b.EndDate)
            : parseDateOrNull(b.EndDate) - parseDateOrNull(a.EndDate)
        case 'name':
        default:
          const nameDiff = a.LastName.localeCompare(b.LastName)
          return sortBy[1] === 'ASC' ? nameDiff : -nameDiff
      }
    })
    .filter((value) => {
      return (
        !filterBy ||
        containsInsensitive(value.LastName, filterBy) ||
        containsInsensitive(value.FirstName, filterBy)
      )
    })

  const onClickRow = (professionalproject: ProfessionalProject) => {
    setSelected({
      ...professionalproject,
      /*      Comment: professionalproject.Comment || '',
      Gift: professionalproject.Gift || GIFTS[0],
      StatusOrderInt: professionalproject.StatusOrderInt || ORDER_STATUSES[0].value,
      StatusOrder: professionalproject.StatusOrder || ORDER_STATUSES[0].label,
      StatusInvoice: professionalproject.StatusInvoice || INVOICE_STATUSES[0],*/
    })
  }

  const onSave = async (gift: ChristmasGift) => {
    gift.StatusOrder = ORDER_STATUSES.find(
      (os) => os.value === gift.StatusOrderInt
    )!.label
    const result = await authedPost(
      `christmas-gifts/${gift.ID}`,
      JSON.stringify(gift)
    )
    if (!result.ok) {
      const json = await result.json()
      setError('Error updating: ' + json.error)
    } else {
      const json = (await result.json()) as ChristmasGift[]
      setChristmasGifts(json)
      setError('')
      setSelected(undefined)
    }
  }

  const onCreate = async (gift: NewChristmasGift) => {
    const result = await authedPost(`christmas-gifts`, JSON.stringify(gift))
    if (!result.ok) {
      const json = await result.json()
      setError('Error creating: ' + json.error)
    } else {
      const json = (await result.json()) as ChristmasGift[]
      setChristmasGifts(json)
      setError('')
      setNewGift(undefined)
    }
  }

  const WIDTHS = [150, 400, 150, 150, 150, 120, 170, 170]

  return (
    <>
      {/* {newGift && (
        <NewModal
          onClose={() => setSelected(undefined)}
          newGift={newGift}
          setNewGift={setNewGift}
          onSave={onCreate}
        />
      )}
      {selected && (
        <EditModal
          onClose={() => setSelected(undefined)}
          selected={selected}
          setSelected={setSelected}
          onSave={onSave}
        />
      )} */}
      <div className="christmas-gifts-container">
        <div className="christmas-gifts-title">
          <div className="flex flex-justify-between">
            <div className="flex flex-container">
              <div>Professionals overview</div>
              <div className="filter">
                Filter
                <input
                  className="input-filter"
                  id="filter"
                  value={filterBy}
                  onChange={(e) => applyFilter(e.target.value)}
                />
              </div>
            </div>
            <button
              className="cg-button"
              onClick={() => setNewGift(DEFAULT_GIFT)}
            >
              New
            </button>
          </div>
        </div>
        {error && <div>{error}</div>}
        <div className="table">
          <div className="flex table-row pm-table-header">
            <div style={{ width: WIDTHS[0] }}>ID</div>
            <div
              className="cursor-pointer"
              style={{ width: WIDTHS[1] }}
              onClick={() => setSorting('name')}
            >
              Professional
            </div>
            <div style={{ width: WIDTHS[2] }}>Project Code</div>
            <div
              className="cursor-pointer"
              style={{ width: WIDTHS[3] }}
              onClick={() => setSorting('dateStart')}
            >
              Start date
            </div>
            <div
              className="cursor-pointer"
              style={{ width: WIDTHS[4] }}
              onClick={() => setSorting('dateEnd')}
            >
              End date
            </div>
            <div style={{ width: WIDTHS[5] }}>Reimbursed</div>
            <div style={{ width: WIDTHS[6] }}>Deductible</div>
          </div>
          {sorted &&
            sorted.map((professionalproject) => (
              <div
                key={`${professionalproject.ID}_${professionalproject.ProjectCode}_${professionalproject.StartDate}`}
                className="flex pm-table-row"
                onClick={() => onClickRow({ ...professionalproject })}
              >
                <div style={{ width: WIDTHS[0] }}>{professionalproject.ID}</div>
                <div style={{ width: WIDTHS[1] }}>
                  {professionalproject.LastName},{' '}
                  {professionalproject.FirstName}
                </div>
                <div style={{ width: WIDTHS[2] }}>
                  {professionalproject.ProjectCode}
                </div>
                <div style={{ width: WIDTHS[3] }}>
                  {professionalproject.StartDate && (
                    <DateCell date={professionalproject.StartDate} />
                  )}
                </div>
                <div style={{ width: WIDTHS[4] }}>
                  {professionalproject.EndDate && (
                    <DateCell date={professionalproject.EndDate} />
                  )}
                </div>
                <div style={{ width: WIDTHS[5] }}>
                  {professionalproject.PRJID &&
                  professionalproject.ExpensesReimbursed
                    ? 'Exp '
                    : ''}
                  {professionalproject.PRJID &&
                  professionalproject.TravelReimbursed
                    ? 'KM'
                    : ''}
                </div>
                <div style={{ width: WIDTHS[6] }}>
                  {professionalproject.PRJID &&
                  professionalproject.TravelDeductible
                    ? 'KM '
                    : ''}
                  {professionalproject.PRJID &&
                  professionalproject.TravelExpensesDeductible
                    ? 'TrvExp '
                    : ''}
                  {professionalproject.PRJID &&
                  professionalproject.ExpensesDeductible
                    ? 'OthExp'
                    : ''}
                </div>
              </div>
            ))}
        </div>
      </div>
    </>
  )
}
